
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerConfigFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canReuseDeleted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alphaLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numericLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numericConfig"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numericPadded"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genericSearchFields"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nominalBusinessCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nominalCustomerAccountSet"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"vatBusinessCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1Label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressLine2Label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressLine3Label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressLine4Label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addressLine5Label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultVatInclusive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditControlNoteType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultCreditLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoAllocateSequence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salesCreditDueDateFromPaymentTerm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewAccountStatusAfterSalesReceipt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":809}};
    doc.loc.source = {"body":"fragment CustomerConfigFragment on CustomerConfig {\n  id\n  concurrencyVersion\n  uuid\n  canReuseDeleted\n  alphaLength\n  numericLength\n  numericConfig\n  numericPadded\n  genericSearchFields\n  nominalBusinessCategory {\n    id\n    concurrencyVersion\n    description\n  }\n  nominalCustomerAccountSet {\n    id\n    concurrencyVersion\n    code\n  }\n  vatBusinessCategory {\n    id\n    concurrencyVersion\n    description\n  }\n  paymentTerm {\n    id\n    concurrencyVersion\n    description\n  }\n  addressLine1Label\n  addressLine2Label\n  addressLine3Label\n  addressLine4Label\n  addressLine5Label\n  defaultVatInclusive\n  creditControlNoteType {\n    id\n    uuid\n    concurrencyVersion\n    title\n    type\n  }\n  defaultCreditLimit\n  autoAllocateSequence\n  salesCreditDueDateFromPaymentTerm\n  reviewAccountStatusAfterSalesReceipt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CustomerConfigFragment"] = oneQuery(doc, "CustomerConfigFragment");
        
